import React, { useEffect, useState } from "react";
import {
    getAverageCheck,
    getCheckCount,
    getOverallIncome,
    getStaffEfficiency,
    getDepartmentEfficiency,
} from "../../utils/dataFetch";

export default function EfficiencyStatistics({ startDate, endDate }) {
    const [error, setError] = useState("");
    const [overallIncome, setOverallIncome] = useState(0);
    const [averageCheck, setAverageCheck] = useState(0);
    const [checkCount, setCheckCount] = useState(0);
    const [staffEfficiency, setStaffEfficiency] = useState([]);
    const [departmentEfficiency, setDepartmentEfficiency] = useState([]);

    useEffect(() => {
        const fetchSalesReport = async () => {
            try {
                const tempStart = new Date(startDate);
                tempStart.setHours(0, 0, 0, 0);
                const tempEnd = new Date(endDate);
                tempEnd.setHours(23, 59, 59, 999);
                const overallIncomeResult = await getOverallIncome(
                    tempStart.toISOString(),
                    tempEnd.toISOString()
                );
                setOverallIncome(overallIncomeResult);
                const averageCheckResult = await getAverageCheck(
                    tempStart.toISOString(),
                    tempEnd.toISOString()
                );
                setAverageCheck(averageCheckResult);
                const checkCountResult = await getCheckCount(
                    tempStart.toISOString(),
                    tempEnd.toISOString()
                );
                setCheckCount(checkCountResult);
                const staffEfficiencyResult = await getStaffEfficiency(
                    tempStart.toISOString(),
                    tempEnd.toISOString()
                );
                setStaffEfficiency(staffEfficiencyResult);
                const departmentEfficiencyResult =
                    await getDepartmentEfficiency(
                        tempStart.toISOString(),
                        tempEnd.toISOString()
                    );
                setDepartmentEfficiency(departmentEfficiencyResult);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };
        fetchSalesReport();
    }, [startDate, endDate]);

    const [showStaffTable, setShowStaffTable] = useState(false);
    const toggleStaffTable = () => setShowStaffTable(!showStaffTable);

    const [showDepartmentTable, setShowDepartmentTable] = useState(false);
    const toggleDepartmentTable = () =>
        setShowDepartmentTable(!showDepartmentTable);

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Статистика ефективносі</h5>
                {error && (
                    <div className="alert alert-danger m-auto rounded-5">
                        {error}
                    </div>
                )}
                {!error && (
                    <>
                        <div className="row d-flex mt-3">
                            <div className="col col-auto m-0 p-0 text-center flex-fill">
                                <div>Заг. дохід</div>
                                <div className="fw-light">{overallIncome}</div>
                            </div>
                            <div className="col col-auto m-0 p-0 text-center flex-fill border-start border-end border-1 border-black">
                                <div>Сер. чек</div>
                                <div className="fw-light">{averageCheck}</div>
                            </div>
                            <div className="col col-auto m-0 p-0 text-center flex-fill">
                                <div>К-сть чеків</div>
                                <div className="fw-light">{checkCount}</div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center">
                            <button
                                className="btn btn-sm main--button mt-3 me-1"
                                onClick={toggleDepartmentTable}
                            >
                                {showDepartmentTable
                                    ? "Сховати Підрозділи"
                                    : "Підрозділи"}
                            </button>
                            <button
                                className="btn btn-sm main--button mt-3 ms-1"
                                onClick={toggleStaffTable}
                            >
                                {showStaffTable
                                    ? "Сховати Персонал"
                                    : "Персонал"}
                            </button>
                        </div>

                        {/* Department Table data */}
                        {showDepartmentTable && (
                            <>
                                {departmentEfficiency.length === 0 && (
                                    <h5 className="text-center mt-3">
                                        Дані відсутні!
                                    </h5>
                                )}
                                {departmentEfficiency.length > 0 && (
                                    <div className="mt-3">
                                        <EfficiencyTable
                                            rows={departmentEfficiency}
                                            labels={[
                                                "Підрозділ",
                                                "Дохід",
                                                "К-сть чеків",
                                                "Сер. чек",
                                            ]}
                                            title={"Підрозділи"}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                        {showDepartmentTable &&
                            departmentEfficiency.length > 8 && (
                                <div className="d-flex justify-content-center mt-3">
                                    <button
                                        className="btn btn-sm main--button"
                                        onClick={toggleDepartmentTable}
                                    >
                                        Сховати Підрозділи
                                    </button>
                                </div>
                            )}

                        {/* Staff Table data */}
                        {showStaffTable && (
                            <>
                                {staffEfficiency.length === 0 && (
                                    <h5 className="text-center mt-3">
                                        Дані відсутні!
                                    </h5>
                                )}
                                {staffEfficiency.length > 0 && (
                                    <div className="mt-3">
                                        <EfficiencyTable
                                            rows={staffEfficiency}
                                            labels={[
                                                "Ім'я",
                                                "Дохід",
                                                "К-сть чеків",
                                                "Сер. чек",
                                            ]}
                                            title={"Персонал"}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                        {showStaffTable && staffEfficiency.length > 8 && (
                            <div className="d-flex justify-content-center mt-3">
                                <button
                                    className="btn btn-sm main--button"
                                    onClick={toggleStaffTable}
                                >
                                    Сховати Персонал
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

function EfficiencyTable({ rows, labels, title }) {
    return (
        <>
            <h5 className="text-center">{title}</h5>
            <div className="table-responsive rounded-4">
                <table className="table table-sm table-striped table-light table-hover m-0">
                    <thead className="thead-dark">
                        <tr>
                            {labels.map((item, index) => (
                                <th
                                    key={index}
                                    className="text-center align-middle"
                                    scope="col"
                                >
                                    {item}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item, index) => (
                            <tr key={index}>
                                <th
                                    className="text-center align-middle"
                                    scope="row"
                                >
                                    {item.name}
                                </th>
                                <td className="text-center align-middle">
                                    {parseFloat(item.total_income).toFixed(2)}
                                </td>
                                <td className="text-center align-middle">
                                    {item.check_count}
                                </td>
                                <td className="text-center align-middle">
                                    {parseFloat(item.avg_check).toFixed(2)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}
